const functions = {
	toggle_switch_acc_dialog: 'toggle_switch_acc_dialog',
	toggle_referral_tos_dialog: 'toggle_referral_tos_dialog',
}

export {functions}